import { useCallback, useEffect, useRef, useState } from 'react';

import { useBreadcrumbContext } from 'components/shared/Breadcrumb/context/BreadcrumbContext';

import { buildLocalEditFromService, mapRowToService } from '../lib/helpers';

const CREATE_SERVICE_STEP = 'create-service';
const EDIT_SERVICE_STEP = 'edit-service';

export const useServiceFormStep = ({ setLocalEdits, handleCreateNewService, isOpen }) => {
  const { currentStep, nextCrumb, goBack, setStepWithTrim } = useBreadcrumbContext();
  const serviceFormRef = useRef(null);
  const [isFormChanged, setIsFormChanged] = useState(false);
  const [editingRow, setEditingRow] = useState(null);

  useEffect(() => {
    if (!isOpen) return;

    setStepWithTrim(0);
    setIsFormChanged(false);
    setEditingRow(null);
  }, [isOpen]);

  const isCreateStep = currentStep === CREATE_SERVICE_STEP;
  const isEditStep = currentStep === EDIT_SERVICE_STEP;

  const handleGoBack = useCallback(() => goBack(), [goBack]);

  const startCreateStep = useCallback(
    () => nextCrumb({ name: CREATE_SERVICE_STEP, title: 'Create new service' }),
    [nextCrumb]
  );

  const handleEditRow = useCallback(
    (rowData) => {
      setEditingRow(rowData);
      nextCrumb({ name: EDIT_SERVICE_STEP, title: 'Edit service' });
    },
    [nextCrumb]
  );

  const handleCreateSave = async (newService) => {
    const success = await handleCreateNewService(newService);
    if (success) handleGoBack();
  };

  const handleEditSave = (updatedService) => {
    setLocalEdits((prev) => ({
      ...prev,
      [editingRow.code]: buildLocalEditFromService(updatedService, editingRow)
    }));
    handleGoBack();
  };

  return {
    serviceFormRef,
    isFormChanged,
    setIsFormChanged,
    isCreateStep,
    isEditStep,
    formService: isEditStep ? mapRowToService(editingRow) : {},
    handleFormSave: isEditStep ? handleEditSave : handleCreateSave,
    submitForm: () => serviceFormRef.current?.submitForm(),
    startCreateStep,
    handleEditRow,
    goBack: handleGoBack
  };
};
